import React from 'react';

import { SharePanelFormSection } from './section';
import { useSharePanelStore } from 'src/common/store/share.store';

const SharePanelFormPersonalizationSectionLink = () => {
  const alias = useSharePanelStore((state) => state.activeAlias);
  const domain = alias?.personalization?.domain;

  return (
    <SharePanelFormSection
      type='personalization'
      title='Personalization'
      subTitle={domain ? `Personalized for ${domain}` : `Add your recipient's logo`}
    />
  );
};

export default SharePanelFormPersonalizationSectionLink;
